import { useNavigate } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { useInView } from "@/hooks/useInView";
import project1 from "@/assets/narjis-hero.webp";
import project2 from "@/assets/qairawan-hero.webp";
import project3 from "@/assets/adwar-narjis-cover.webp";
import project4Asset from "@/assets/aqiq-cover-dusk.webp.asset.json";
const project4 = project4Asset.url;
import project5Asset from "@/assets/malqa-cover.png.asset.json";
const project5 = project5Asset.url;

const ProjectsSection = () => {
  const navigate = useNavigate();
  const { t, lang } = useI18n();
  const [headerRef, headerInView] = useInView();
  const [gridRef, gridInView] = useInView();

  const projects = [
    // Available for sale first
    {
      title: t("projects.p3.title"),
      description: t("projects.p3.desc"),
      image: project3,
      status: t("projects.p3.status"),
      statusColor: "bg-green-500",
      area: "180-250 m²",
      units: t("projects.p3.units"),
      link: "/adwar",
    },
    {
      title: t("projects.p4.title"),
      description: t("projects.p4.desc"),
      image: project4,
      status: t("projects.p4.status"),
      statusColor: "bg-green-500",
      area: "185-245 m²",
      units: t("projects.p4.units"),
      link: "/aqiq",
    },
    // Coming soon
    {
      title: t("projects.p5.title"),
      description: t("projects.p5.desc"),
      image: project5,
      status: t("projects.p5.status"),
      statusColor: "bg-amber-500",
      area: "—",
      units: t("projects.p5.units"),
      link: null,
      comingSoon: true,
    },
    {
      title: t("projects.p6.title"),
      description: t("projects.p6.desc"),
      image: project5,
      status: t("projects.p6.status"),
      statusColor: "bg-amber-500",
      area: "—",
      units: t("projects.p6.units"),
      link: null,
      comingSoon: true,
    },
    // Sold out
    {
      title: t("projects.p1.title"),
      description: t("projects.p1.desc"),
      image: project1,
      status: t("projects.p1.status"),
      statusColor: "bg-red-500",
      area: "230-270 m²",
      units: t("projects.p1.units"),
      link: "/narjis",
    },
    {
      title: t("projects.p2.title"),
      description: t("projects.p2.desc"),
      image: project2,
      status: t("projects.p2.status"),
      statusColor: "bg-red-500",
      area: "483-570 m²",
      units: t("projects.p2.units"),
      link: "/qairawan",
    },
  ];

  return (
    <section id="projects" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-6">
        <div
          ref={headerRef}
          className={`text-center mb-16 anim-fade-up ${headerInView ? "in-view" : ""}`}
        >
          <span className={`text-cream text-sm font-bold ${lang === "en" ? "tracking-widest" : ""}`}>{t("projects.label")}</span>
          <h2 className={`text-4xl md:text-5xl font-black text-foreground mt-3 ${lang === "en" ? "font-houstiq" : ""}`}>{t("projects.title")}</h2>
          <div className="w-20 h-1 bg-cream mx-auto mt-4 rounded-full" />
        </div>

        <div ref={gridRef} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={project.title}
              className={`group bg-card rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-border flex flex-col anim-fade-up ${gridInView ? "in-view" : ""}`}
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <div className="relative overflow-hidden h-64">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent" />
                <span className={`absolute top-4 ${lang === "en" ? "left-4" : "right-4"} ${project.statusColor} ${project.statusColor === "bg-red-500" ? "text-white" : "text-cream"} text-xs font-bold px-3 py-1.5 rounded-full shadow-md`}>
                  {project.status}
                </span>
              </div>

              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-card-foreground mb-2">{project.title}</h3>
                <p className="text-muted-foreground text-sm mb-4 leading-relaxed flex-1">{project.description}</p>
                <div className="flex items-center justify-between text-sm mb-5">
                  <span className="text-cream font-semibold">{project.area}</span>
                  <span className="text-muted-foreground">{project.units}</span>
                </div>
                <button
                  onClick={() => project.link ? navigate(project.link) : null}
                  disabled={!!project.comingSoon}
                  className="w-full bg-cream text-navy font-bold py-3 rounded-xl text-sm hover:opacity-90 transition-opacity disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {project.comingSoon ? t("projects.comingSoon") : t("projects.viewDetails")}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
